import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Address} from "../../models/address.model";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";

export class MapAddressAutocompleteCtrl implements IController {

  address: any;
  types: any;

  onChange: Function;

  private autocompleteService: any;
  private geocoder: any;
  private defaultTypes: any;
  private selectedItem: any;

  /* @ngInject */
  constructor(private $log, private analyticsService: AnalyticsService) {
  }

  $onInit() {
    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.geocoder = new google.maps.Geocoder;
    this.defaultTypes = ['geocode'];  // '(cities)'

    this.setSelectedItem();
  };

  $onChanges(changes) {
    if (changes.address && !changes.address.isFirstChange()){
      this.$onInit();
    }
  };

  setSelectedItem() {
    const place = _.get(this.address, 'place');
    if(place){
      this.selectedItem = {
        description : place
      };
    }else {
      this.selectedItem = undefined;
    }
  }

  querySearch(query) {
    var types = this.types ? [this.types] : this.defaultTypes;
    return this.getPlacePredictions(query, types);
  }

  selectedItemChange(item) {

    if(item){

      if(!item.place_id) return;

      this.geocode(item.place_id).then((place) => {
        const address = this.placeToAddress(place);
        this.onChange({address: address});
      },() => {
        this.$log.error('selectedItemChange fail');
      });
    }else {
      this.onChange({address: {}});
    }
  }

  getPlacePredictions(input, types) {
    return new Promise((resolve, reject) => {
      this.autocompleteService.getPlacePredictions({
        input: input,
        types: types
      },(predictions, status) => {

        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(predictions);
        }
        else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          resolve([]);
        }
        else{
          this.$log.error('getPlacePredictions fail', status);
          reject(status);
        }
      });
    });
  }

  geocode(placeId) {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ placeId: placeId}, (place, status) => {
        this.analyticsService.trackEvent('Geocode', 'mapAddressAutocomplete', status);
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(place[0]);
        } else {
          this.$log.error('geocode fail', status);
          reject(status);
        }
      });
    });
  }

  placeToAddress(place): Address{

    if (place.address_components.length < 3) return {};

    function getTypeValue(type) {
      for (var i = 0; i < place.address_components.length; i++) {
        var component = place.address_components[i];
        for (var j = 0; j < component.types.length; j++) {
          var componentType = component.types[j];
          if (componentType === type) {
            return component.long_name;
          }
        }
      }
      return undefined;
    }

    return {
      house : getTypeValue('street_number'),
      neighborhood: getTypeValue('neighborhood'),
      street : getTypeValue('route') || getTypeValue('neighborhood'),
      city : getTypeValue('locality'),
      country : getTypeValue('country'),
      state : getTypeValue("administrative_area_level_1"),
      location : {
        longitude: place.geometry.location.lng(),
        latitude: place.geometry.location.lat()
      },
      place : place.formatted_address,
      placeId : place.place_id
    };

  }

}

angular
  .module('bringoz.admin.addresses')
  .component('mapAddressAutocomplete', {
    bindings: {
      address : '<',
      types: '@?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./map-address-autocomplete.html').default,
    controller: MapAddressAutocompleteCtrl
  });
